import { render } from "./AddNewSkill.vue?vue&type=template&id=02a3c7ed&scoped=true&ts=true"
import script from "./AddNewSkill.vue?vue&type=script&lang=ts"
export * from "./AddNewSkill.vue?vue&type=script&lang=ts"

import "./AddNewSkill.vue?vue&type=style&index=0&id=02a3c7ed&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\stani\\OneDrive\\Documents\\Git\\fate-extended\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a3c7ed"]])

export default __exports__